import { FeatureIcon } from '@components/icons/SvgIcons'
import { MainLayout } from '@components/layouts/MainLayout'
import { IconButton } from '@components/ui/IconButton'
import { motion } from 'framer-motion'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const Notifications: React.FC = () => {
  const navigate = useNavigate()
  const [isVisible, setIsVisible] = useState(false)
  const [isClosing, setIsClosing] = useState(false)
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const frame = requestAnimationFrame(() => setIsVisible(true))
    return () => {
      cancelAnimationFrame(frame)
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current)
      }
    }
  }, [])

  const transition = useMemo(
    () => ({
      duration: 0.32,
      ease: [0.4, 0, 0.2, 1] as [number, number, number, number],
    }),
    []
  )

  const handleBack = useCallback(() => {
    if (isClosing) return
    setIsClosing(true)
    setIsVisible(false)
    closeTimerRef.current = setTimeout(() => {
      navigate(-1)
    }, transition.duration * 1000)
  }, [isClosing, navigate, transition.duration])

  return (
    <motion.div
      className="min-h-screen w-full"
      initial={{ x: '-100%', opacity: 0 }}
      animate={{ x: isVisible ? 0 : '-100%', opacity: isVisible ? 1 : 0 }}
      transition={transition}
    >
      <MainLayout
        activeMain={null}
        showBottomNav={false}
        outerClassName="bg-white"
        className="bg-white"
        contentClassName="px-4 pb-10"
        header={{
          enabled: true,
          title: 'お知らせ',
          leftIcon: null,
          rightIcon: null,
          leftSlot: <IconButton aria-label="戻る" icon="Back" onClick={handleBack} />,
          rightSlot: (
            <IconButton
              aria-label="メニュー"
              icon="Dots"
              className="invisible pointer-events-none"
            />
          ),
          className: 'flex h-16 w-full items-center justify-between px-6',
          containerClassName: 'px-4 pt-4',
          scrolledClassName: 'supports-[backdrop-filter]:backdrop-blur-[1px]',
        }}
      >
        <div className="flex min-h-full flex-col">
          <div className="flex flex-1 justify-center">
            <div className="w-full max-w-[360px]">
              <section className="w-full">
                <div className="flex flex-col items-center gap-6 px-8 py-10">
                  <span className="flex h-12 w-12 items-center justify-center">
                    <FeatureIcon className="h-6 w-6" decorative />
                  </span>
                  <p className="text-sm font-medium leading-5 tracking-[-0.005em] text-[#18181B]">
                    Coming Soon...
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </MainLayout>
    </motion.div>
  )
}

export default Notifications
